import { useGetParsedQuery } from "@src/appV2/api/useGetParsedQuery";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { z } from "zod";

const facilitySchema = z
  .object({
    _id: z.string(),
    name: z.string(),
    userId: z.string(),
  })
  .passthrough();

export const currentUserResponseSchema = z.object({
  user: z
    .object({
      _id: z.string(),
      email: z.string(),
      firstName: z.string(),
      lastName: z.string(),
      name: z.string(),
      phone: z
        .string()
        .nullish()
        .transform((v) => v ?? ""),
      workplacePhone: z
        .string()
        .nullish()
        .transform((v) => v ?? ""),
      designation: z
        .string()
        .nullish()
        .transform((v) => v ?? ""),
      firebaseId: z.string(),
      roles: z.array(z.string()),
      facilities: z.array(facilitySchema).optional(),
      alertSettings: z.record(z.string(), z.record(z.string(), z.unknown())).optional(),
      notify: z.record(z.string(), z.record(z.string(), z.boolean())).optional(),
      permissions: z.array(z.string()).optional().default([]),
      // Signed JWT for the Knock JS SDK.
      knockToken: z.string().optional(),
    })
    .passthrough(),
});

export function useGetCurrentUser() {
  return useGetParsedQuery({
    url: "/facilityUser/findByEmail",
    responseSchema: currentUserResponseSchema,
    meta: { logErrorMessage: APP_V2_APP_EVENTS.GET_CURRENT_USER_FAILURE },
  });
}
